import React from 'react'

import ClearClientMessage from '@/components/misc/ClearClientMessage'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface Props {
  selectedClientName?: string
  onOpenSelectionModal: () => void
  onClearSelection: () => void
  selectTextClassName?: string
}

const SelectExistingClientMessage: React.FC<Props> = ({
  selectedClientName,
  onOpenSelectionModal,
  onClearSelection,
  selectTextClassName,
}) => {
  if (selectedClientName) {
    return (
      <ClearClientMessage
        selectedClientName={selectedClientName}
        onClear={onClearSelection}
      />
    )
  }

  return (
    <p className={cn('mb-2', selectTextClassName)}>
      Select a client from your{' '}
      <Button
        variant="plain"
        className="font-bold hover:underline"
        onClick={onOpenSelectionModal}
        type="button"
      >
        your contacts list
      </Button>{' '}
      or add their details below
    </p>
  )
}

export default SelectExistingClientMessage
